import { TemplateRef, ViewContainerRef } from '@angular/core';

export class BsComponentRef<T> {
  templateRef: TemplateRef<T>;
  viewContainer: ViewContainerRef;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
